/**
 * @file element-line.ts
 * @description Линия элемента секции `{width, color?}` — разделитель
 * вопросов и линии таблицы (phase19.16, партия SB120, этап 3б; данные
 * db-design-sb120-stage3 §1): канон записи и подпись толщин таблицы. Ширина «как было» без своего
 * цвета — нет ключа (как было до 3б), иначе объект целиком.
 */

import { tableLineWidths, type SectionFaqDivider } from "@chaiberi/shared";

/** Линия: толщина px и цвет-ссылка (нет — «Авто: линия»). Форма одна у разделителя и линий таблицы. */
export type ElementLine = SectionFaqDivider;

/** Канон линии: «как было» без цвета — `undefined` (ключ снимается). */
export function lineValue(width: number, color: ElementLine["color"], def: number): ElementLine | undefined {
  if (width === def && !color) return undefined;
  return color ? { width, color } : { width };
}

/** Подпись толщин линий таблицы по shared `tableLineWidths`: «Между строками 1 px, под шапкой 2 px» / «Без линий». */
export function tableLinesHint(lines: ElementLine | undefined): string {
  const { row, head } = tableLineWidths(lines);
  if (row === 0 && head === 0) return "Без линий.";
  return `Между строками ${row} px, под шапкой ${head} px.`;
}
